import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export interface GodModeTask {
  id?: string;
  _id?: string;
  status: string;
  due_date?: string;
  [key: string]: any;
}

export interface GodModeUser {
  id?: string;
  _id?: string;
  department?: string;
  role?: string;
  [key: string]: any;
}

export interface GodModeData {
  tasks: GodModeTask[];
  users: GodModeUser[];
}

const fetchGodModeData = async (): Promise<GodModeData> => {
  const [tasksRes, usersRes] = await Promise.all([
    api.get<{ tasks?: GodModeTask[] } | GodModeTask[]>('/api/tasks'),
    api.get<{ users?: GodModeUser[] } | GodModeUser[]>('/api/admin/users'),
  ]);

  const tasksData = tasksRes.data;
  const usersData = usersRes.data;

  // The legacy code unpacks `res.tasks` or uses the array directly
  const tasks = Array.isArray(tasksData) ? tasksData : tasksData?.tasks || [];
  const users = Array.isArray(usersData) ? usersData : usersData?.users || [];

  return { tasks, users };
};

export function useGodMode<TData = GodModeData>(
  select?: (data: GodModeData) => TData
) {
  return useQuery({
    queryKey: ['godModeData'],
    queryFn: fetchGodModeData,
    select,
    refetchInterval: 60000, // Matching DashboardLayoutEngine refresh standard
  });
}
